import React from "react";

import { Switch, Route, Redirect } from "react-router-dom";

import Home from "./../pages/NewHome/";
import PropertiesList from "./../pages/PropertiesList";
import PropertyDetails from "./../pages/PropertyDetails";
import CondominiumScreen from "./../pages/CondominiumScreen/";
import LaCitta from "./../pages/LaCitta/";
import Schedule from "./../pages/Schedule/";
import Login from "./../pages/Login/";
import Register from "./../pages/Register/";
import CompleteRegistration from "./../pages/CompleteRegistration/";
import FavoriteProperites from "./../pages/FavoriteProperties/";
import MyProperties from "./../pages/MyProperties/";
import Proposals from "./../pages/Proposals/";
import ProposalReceived from "./../pages/ProposalReceived/";
import ScheduledVisits from "./../pages/ScheduledVisits/";
import ScheduleProcess from "./../pages/ScheduleProcess/";
import SendDocumentation from "./../pages/SendDocumentation/";
import MyAccount from "./../pages/MyAccount/";
import Error404 from "./../pages/404/";
import ScheduleSuccess from "./../pages/ScheduleSuccess/";

import ForgotPassword from "./../pages/ForgotPassword/";
import ResetPassword from "./../pages/ResetPassword/";

import AnunciarImovel from "./../pages/AnunciarImovel/";
import IndicateProperty from "./../pages/IndicateProperty/";
import AboutUs from "./../pages/AboutUs/";
import RequestTermination from "../pages/RequestTermination";
import RequestTerminationUploadDocs from "../pages/RequestTerminationUploadDocs";
import SignContract from "../pages/SignContract";
import OwnerRentProcess from "../pages/OwnerRentProcess";
import TenantDashboard from "../pages/TenantDashboard/";
import OwnerDashboard from "../pages/OwnerDashboard";
import UseTerms from "../pages/UseTerms";
import PrivacyPolitics from "../pages/PrivacyPolitics";
import HousingProgramInfo from "../pages/HousingProgramInfo";
import PhotoGallery from "../components/PhotosGallery";
import PropertyAdvertising from "../pages/PropertyAdvertising";
import UserDocuments from "../pages/UserDocuments";
import PublicSendDocuments from "../pages/PublicSendDocuments";
import AuthCallback from "../pages/AuthCallback/";
import PrivateRoute from "../components/PrivateRoute";
import StyleGuide from "../pages/StyleGuide";
import AccessManagement from "../pages/AccessManagement";


const AppRoutes: React.FC = () => {
  return (
    <Switch>
      <Route
        path="//auth/callback"
        render={({ location }) => (
          <Redirect to={`/auth/callback${location.search || ""}`} />
        )}
      />

      {/* Public routes */}
      <Route path="/" exact component={Home} />
      <Route path="/search" component={PropertiesList} />
      <Route path="/auth/callback" component={AuthCallback} />

      <Route path="/imovel/:id/photos" component={PhotoGallery} exact />
      <Route path="/imovel/:id" component={PropertyDetails} exact />

      <Route path="/condominium" component={CondominiumScreen} />
      <Route path="/schedule/:id" component={Schedule} exact />
      <Route path="/schedule/:id/success" component={ScheduleSuccess} exact />
      <Route path="/login" component={Login} />
      <Route path="/register" component={Register} />
      <Route path="/complete-registration" component={CompleteRegistration} />
      <Route path="/forgot-password" component={ForgotPassword} />
      <Route path="/password/reset/:token" component={ResetPassword} />
      <Route path="/anunciar-imovel" component={AnunciarImovel} />
      <Route path="/indicar-imovel" component={IndicateProperty} />
      <Route path="/about-us" component={AboutUs} />
      <Route path="/public/send-documents" component={PublicSendDocuments} />
      <Route path="/use-terms" component={UseTerms} />
      <Route path="/privacy-politics" component={PrivacyPolitics} />
      <Route path="/his-hmp" component={HousingProgramInfo} />
      <Route path="/advertise-property" component={PropertyAdvertising} />
      <Route path="/jsmart" component={CondominiumScreen} />
      <Route path="/laCitta" component={LaCitta} />

      {/* Protected routes (require authentication) */}
      <PrivateRoute path="/favorites" component={FavoriteProperites} />
      <PrivateRoute path="/my-properties" component={MyProperties} />
      <PrivateRoute path="/proposals" component={Proposals} />
      <PrivateRoute path="/proposal-received/:id" component={ProposalReceived} />
      <PrivateRoute path="/request-termination" component={RequestTermination} />
      <PrivateRoute
        path="/request-termination-upload-documents"
        component={RequestTerminationUploadDocs}
      />
      <PrivateRoute path="/scheduled-visits" component={ScheduledVisits} />
      <PrivateRoute path="/schedule-process" component={ScheduleProcess} />
      <PrivateRoute path="/owner-rent-process" component={OwnerRentProcess} />
      <PrivateRoute path="/send-documentation" component={SendDocumentation} />
      <PrivateRoute path="/user-documents" component={UserDocuments} />
      <PrivateRoute path="/sign-contract" component={SignContract} />
      <PrivateRoute path="/tenant-dashboard" component={TenantDashboard} />
      <PrivateRoute path="/owner-dashboard" component={OwnerDashboard} />
      <PrivateRoute path="/access-management" component={AccessManagement} />
      <PrivateRoute path="/me" component={MyAccount} />

      <Route path="/404" component={Error404} />
      <Route path="/style-guide" component={StyleGuide} />

      <Route component={Error404} />
    </Switch>
  );
};

export default AppRoutes;